<form #customizeForm="ngForm" class="customize">

  <!-- Fastext -->
  @if (isFastext) {
    @if (titleErrors?.maxlength) {
      <div class="error-msg">
        Formatted text exceeds maximum length of {{titleErrors.maxlength.requiredLength}}
        chars
        (current length is {{titleErrors.maxlength.actualLength}} chars).
      </div>
    }
    <!-- fastext text -->
    <app-rich-text-editor class="rich-edit" name="Title" [(ngModel)]="unit.title" maxlength="1000"></app-rich-text-editor>
    <!-- fastext button text -->
    @if(showField('fastextButtonText')) {
      <mat-form-field>
        <mat-label>{{'Button Text' | translate}}</mat-label>
        <input matInput name="buttonText" [(ngModel)]="unit.buttonText">
      </mat-form-field>
    }

    @if(unit.buttonText) {
      <div class="horizontal-form-fields" style="margin-bottom: 20px;">
        <!-- fastext button background color -->
        <app-color-picker-input [(ngModel)]="unit.buttonBackgroundColor" name="buttonBackgroundColor"
        label="{{'Buttons Background Color' | translate}}"></app-color-picker-input>
        <!-- fastext button text color -->
        <app-color-picker-input [(ngModel)]="unit.buttonTextColor" name="buttonTextColor"
        label="{{'Buttons Text Color' | translate}} "></app-color-picker-input>
      </div>
    }
    <!-- fastext background type -->
    <mat-form-field>
      <mat-label>{{'Background' | translate}}</mat-label>
      <mat-select [value]="backgroundType" (selectionChange)="onBackgroundTypeChange($event.value)"
        class="padding-horizontal-4">
        <mat-option value="color" translate>Color</mat-option>
        <mat-option value="image" translate>Image</mat-option>
        <mat-option value="none" translate>No Background</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- fastext background color -->
    @if(backgroundType === 'color') {
      <app-color-picker-input
        name="backgroundColor"
        [(ngModel)]="unit.backgroundColor"
        label="Background Color"
      style="margin-bottom: 20px"></app-color-picker-input>
    }
    <!-- fastext background image -->
    @if (backgroundType === 'image') {
      <div>
        <div translate>Media</div>
        <app-img-uploader uploadPath="tasks_logo" [imageLink]="unit.imgUrl" [isTemplateLibImage]="isPreStyleEdit"
          (imageUploaded)="unit.imgUrl = $event; lastImageUrl = $event">
        </app-img-uploader>
      </div>
    }
    <!-- height -->
    <div class="horizontal-form-fields">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{'Height' | translate}}</mat-label>
        <mat-select [(value)]="isHeightCustom" (selectionChange)="unit.height = $event.value ? unit.height : undefine">
          <mat-option [value]="false" translate>Auto</mat-option>
          <mat-option [value]="true" translate>Custom</mat-option>
        </mat-select>
      </mat-form-field>
      @if(isHeightCustom) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{'Height' | translate}}</mat-label>
          <input matInput name="height" [(ngModel)]="unit.height" appDigitsOnly autocomplete="off" max="500" required>
          <span matTextSuffix>px</span>
          @if (customizeForm.form.get('height')?.errors?.max) {
            <mat-error>
              <span translate>Max height</span> {{customizeForm.form.get('height').errors.max.value}}px
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
    <!-- width -->
    <div class="horizontal-form-fields">
      <mat-form-field>
        <mat-label>{{'Width' | translate}}</mat-label>
        <mat-select [(value)]="isWidthCustom" (selectionChange)="unit.width = $event.value ? unit.width : undefine">
          <mat-option [value]="false" translate>Auto</mat-option>
          <mat-option [value]="true" translate>Custom</mat-option>
        </mat-select>
      </mat-form-field>
      @if(isWidthCustom) {
        <mat-form-field>
          <mat-label>{{'Width' | translate}}</mat-label>
          <input matInput name="width" [(ngModel)]="unit.width" appDigitsOnly autocomplete="off" required>
          <span matTextSuffix>px</span>
        </mat-form-field>
      }
    </div>
  }

  @if (!isFastext) {
    @if(showField('customHtml')) {
      <mat-form-field class="form-field-textarea mt-2">
        <mat-label>{{'Custom Html' | translate}}</mat-label>
        <textarea matInput rows="5" placeholder="&lt;!-- YOUR HTML GOES HERE, NO JS ALLOWED--&gt;" name="customHtml"
        [(ngModel)]="unit.customHtml"></textarea>
      </mat-form-field>
    }

    @if(isOnlyImage) {
      <!-- Title header -->
      @if(!isPowerbarImage && showField('title') && isStyleUnit) {
        <div  (click)="showTitle = !showTitle" class="section-title collapsable" translate>
          <div translate>Title</div>
          <mat-icon>
            @if (showTitle) {expand_less} @else {expand_more}
            </mat-icon>
          </div>

          <!-- Title content -->
          @if (showTitle) {
            <div animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
              <!-- Title text -->
              <mat-form-field subscriptSizing="dynamic" class="form-field">
                <mat-label>{{'Text' | translate}}</mat-label>
                <input matInput name="Title" [(ngModel)]="unit.title">
              </mat-form-field>
              <!-- Title text color -->
              <app-color-picker-input [(ngModel)]="unit.textColor" name="textColor"
              label="{{'Text Color' | translate}}"></app-color-picker-input>
              <!-- Title text size -->
              <div class="form-field-bottom-marging-x3">
                <app-drop-down
                  placeholder="Text Size"
                  name="titleSize"
                  [items]="textSize"
                  [showClearButton]="true"
                  [(ngModel)]="unit.titleSize"
                  >
                </app-drop-down>
              </div>
            </div>
          }
        }


        <!-- Subtitle header -->
        @if(showField('subTitle')) {
          <div (click)="showSubTitle = !showSubTitle" class="section-title collapsable" translate>
            <div translate>Subtitle</div>
            <mat-icon>
              @if (showSubTitle) {expand_less} @else {expand_more}
              </mat-icon>
            </div>

            <!-- Subtitle content -->
            @if (showSubTitle && isRecommendCarouselImage) {
              <div animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
                <!-- Subtitle text -->
                <mat-form-field subscriptSizing="dynamic" class="form-field">
                  <mat-label>{{'Text' | translate}}</mat-label>
                  <input matInput name="Subtitle" [(ngModel)]="unit.subTitle">
                </mat-form-field>
                <!-- Subtitle text color -->
                <app-color-picker-input [(ngModel)]="unit.secondaryTextColor" name="secondaryTextColor"
                label="{{'Text Color' | translate}}"></app-color-picker-input>
                <!-- Subtitle text size -->
                <div class="form-field-bottom-marging-x3">
                  <app-drop-down
                    placeholder="Text Size"
                    name="subTitleSize"
                    [items]="textSize"
                    [showClearButton]="true"
                    [(ngModel)]="unit.subTitleSize"
                    >
                  </app-drop-down>
                </div>
              </div>
            }
          }

          <!-- Button header -->
          @if (unit.uiType !== 'recommend' || !isRecommendCarousel) {
            @if(showField('buttonText')) {
              <div (click)="showButton = !showButton" class="section-title collapsable" translate>
                <div translate>Button</div>
                <mat-icon>
                  @if (showButton) {expand_less} @else {expand_more}
                  </mat-icon>
                </div>
                <!-- Button content -->
                @if (isSliderSideArrow && showButton) {
                  <div animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
                    <!-- Button text -->
                    <mat-form-field subscriptSizing="dynamic" class="form-field">
                      <mat-label>{{'Text' | translate}}</mat-label>
                      <input matInput name="Button" [(ngModel)]="unit.buttonText" required>
                    </mat-form-field>
                    <!-- Button text color -->
                    <app-color-picker-input [(ngModel)]="unit.buttonTextColor" name="buttonTextColor"
                    label="{{'Text Color' | translate}}"></app-color-picker-input>
                    <!-- Button background color -->
                    <app-color-picker-input [(ngModel)]="unit.buttonBackgroundColor" name="buttonBackgroundColor"
                    label="{{'Background color' | translate}}"></app-color-picker-input>
                    <!-- Button text size -->
                    <div class="form-field-bottom-marging-x3">
                      <app-drop-down
                        placeholder="Text Size"
                        name="buttonTextSize"
                        [items]="textSize"
                        [showClearButton]="true"
                        [(ngModel)]="unit.buttonTextSize"
                        >
                      </app-drop-down>
                    </div>
                  </div>
                }
              }
            }
          }

          <!-- Success text header -->
          @if(showField('successText')) {
            <div (click)="showSuccessText = !showSuccessText" class="section-title collapsable" translate>
              <div translate>Thank you message</div>
              <mat-icon>
                @if (showSuccessText) {expand_less} @else {expand_more}
                </mat-icon>
              </div>
              <!-- Success text content -->
              @if (showSuccessText) {
                <div animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
                  <mat-form-field  subscriptSizing="dynamic" class="form-field">
                    <mat-label>{{'Text' | translate}}</mat-label>
                    <input matInput name="successText" [(ngModel)]="unit.successText">
                  </mat-form-field>
                  <!-- Success text text color -->
                  <app-color-picker-input [(ngModel)]="unit.successTextColor" name="successTextColor"
                  label="{{'Text Color' | translate}}"></app-color-picker-input>
                  <!-- Success text text size -->
                  <div class="form-field-bottom-marging-x3">
                    <app-drop-down
                      placeholder="Text Size"
                      name="successTextSize"
                      [items]="textSize"
                      [showClearButton]="true"
                      [(ngModel)]="unit.successTextSize"
                      >
                    </app-drop-down>
                  </div>
                </div>
              }
            }

            @if(unit.uiType ==='form') {
              <div style="height: 15px;"></div>
            }

            <!-- recommend config -->
            @if (unit.uiType ==='recommend' && !isRecommendCarousel) {
              <!-- recommend max pages -->
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>{{'Max Pages to display' | translate}}</mat-label>
                <mat-select [(ngModel)]="unit.recommendationsLimit" class="padding-horizontal-4" name="recommendationsLimit">
                  @for (rec of setOfAllowedRecommendations; track rec) {
                    <mat-option [value]="rec"> {{rec}} </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <!-- recommend content pool -->
              @if(!isPreStyleEdit) {
                <mat-form-field>
                  <mat-label>{{'Content pool source' | translate}}</mat-label>
                  <mat-select [(ngModel)]="unit.contentPoolId" class="padding-horizontal-4" name="contentPoolId">
                    <mat-option [value]="-1" translate>All Content</mat-option>
                    @for (pool of contentPools; track pool) {
                      <mat-option [value]="pool.id"> {{pool.name}}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-hint><a routerLink="/cm/configure/website/content_pool/add" (click)="beforeUnloadingMarker()">
                  {{'create new' | translate}}</a>
                </mat-hint>
              </mat-form-field>
            }
            <!-- recommend tags -->
            @if(showField('recommendTags')) {
              <div>
                <mat-checkbox class="no-left-margin" [checked]="unit.showRecommendTags" [(ngModel)]="unit.showRecommendTags"
                name="showRecommendTags">{{'Show recommend tags' | translate}} </mat-checkbox>
              </div>
            }
            <!-- recommend areas -->
            @if(showField('recommendArea')) {
              <div>
                <mat-checkbox class="no-left-margin" [checked]="unit.showRecommendArea" [(ngModel)]="unit.showRecommendArea"
                name="showRecommendArea">{{'Show recommend area' | translate}} </mat-checkbox>
              </div>
            }
            <div class="vertical-field-spacer"></div>
          }

          <!-- recommend carousel config -->
          @if(unit.uiType ==='recommend' && isRecommendCarousel) {
            <!-- recommend carousel max display pages -->
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{'Max Pages to display' | translate}}</mat-label>
              <mat-select [(ngModel)]="unit.recommendCarouselDisplayLimit" (ngModelChange)="onMaxDisplayPagesChange()"
                class="padding-horizontal-4" name="recommendCarouselDisplayLimit">
                @for (rec of maxRecommendCarouselDisplayOption; track rec) {
                  <mat-option [value]="rec"> {{rec}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- recommend carousel max pages -->
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{'Max Pages to recommend' | translate}}</mat-label>
              <mat-select [(ngModel)]="unit.recommendationsLimit" class="padding-horizontal-4" name="recommendationsLimit">
                @for (rec of setOfAllowedRecommendations; track rec) {
                  <mat-option [value]="rec"
                  [disabled]="rec < unit.recommendCarouselDisplayLimit"> {{rec}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- recommend carousel content pool -->
            @if (!isPreStyleEdit) {
              <mat-form-field>
                <mat-label>{{'Content pool source' | translate}}</mat-label>
                <mat-select [(ngModel)]="unit.contentPoolId" class="padding-horizontal-4" name="contentPoolId">
                  <mat-option [value]="-1" translate>All Content</mat-option>
                  @for (pool of contentPools; track pool) {
                    <mat-option [value]="pool.id"> {{pool.name}}
                    </mat-option>
                  }
                </mat-select>
                <mat-hint><a routerLink="/cm/configure/website/content_pool/add" (click)="beforeUnloadingMarker()">
                {{'create new' | translate}}</a>
              </mat-hint>
            </mat-form-field>
          }
          @if(isOnlyImage) {
            <!-- recommend carousel bg color -->
            <mat-checkbox class="no-left-margin" [checked]="isAdvancedBg" (change)="onAdvanceBgChange($event.checked)">
              {{'Advanced Background' | translate}}
            </mat-checkbox>
            @if (!isAdvancedBg) {
              <app-color-picker-input [(ngModel)]="unit.backgroundColor" name="backgroundColor"
              label="Background Color"> </app-color-picker-input>
            }
            @if (isAdvancedBg) {
              <mat-form-field>
                <mat-label>{{'Background' | translate}}</mat-label>
                <input matInput placeholder="url()" required [(ngModel)]="unit.backgroundColor" name="backgroundColor"
                  spellcheck="false">
                  <mat-hint>url() or gradient()
                    <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/background" target="_blank">more info</a>
                  </mat-hint>
                </mat-form-field>
              }
              @if(!showField('title')) {
                <!-- recommend carousel text color -->
                <app-color-picker-input [(ngModel)]="unit.textColor" name="textColor"
                label="{{'Text Color' | translate}}"></app-color-picker-input>
              }
            }
            <!-- recommend carousel indicator -->
            <div style="margin-top: 10px;">
              <mat-checkbox class="no-left-margin" [checked]="unit.recommendCarouselShowIndicator"
                [(ngModel)]="unit.recommendCarouselShowIndicator" name="recommendCarouselShowIndicator">
              {{'Show Carousel Indicators' | translate}} </mat-checkbox>
            </div>
            @if (unit.recommendCarouselShowIndicator) {
              <app-color-picker-input
                [(ngModel)]="unit.recommendCarouselIndicatorColor" name="recommendCarouselIndicatorColor"
                label="Indicator Color" animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
              </app-color-picker-input>
            }
            <!-- recommend carousel button -->
            <div style="margin-top: 10px;">
              <mat-checkbox class="no-left-margin" [checked]="isShowButton" [(ngModel)]="isShowButton"
                (ngModelChange)="onShowButtonChange($event)" name="isShowButton">
                {{'Show Read More Button' | translate}}
              </mat-checkbox>
            </div>
            @if (isShowButton) {
              <div style="max-width: 400px;" animate.enter="app-collapse-expand-enter" animate.leave="app-collapse-expand-leave">
                <mat-form-field class="full-width" subscriptSizing="dynamic">
                  <mat-label>Button Text</mat-label>
                  <input matInput name="buttonText" [(ngModel)]="unit.buttonText" required>
                </mat-form-field>
                <app-color-picker-input [(ngModel)]="unit.buttonBackgroundColor" name="buttonBackgroundColor"
                label="Buttons Background Color"></app-color-picker-input>
                <app-color-picker-input [(ngModel)]="unit.buttonTextColor" name="buttonTextColor"
                label="Buttons Text Color"></app-color-picker-input>
              </div>
            }
            <!-- recommend carousel tags -->
            <div>
              <mat-checkbox class="no-left-margin" [checked]="unit.showRecommendTags" [(ngModel)]="unit.showRecommendTags"
              name="showRecommendTags"> {{'Show recommend tags' | translate}} </mat-checkbox>
            </div>
            <!-- recommend carousel areas -->
            <div>
              <mat-checkbox class="no-left-margin" [checked]="unit.showRecommendArea" [(ngModel)]="unit.showRecommendArea"
              name="showRecommendArea"> {{'Show recommend area' | translate}} </mat-checkbox>
            </div>
          }

          <!-- survey config -->
          @if (unit.uiType === 'survey') {
            <div class="section-title">Questions</div>
            <app-color-picker-input [(ngModel)]="unit.secondaryTextColor" name="secondaryTextColor"
            label="{{'Question Text Color' | translate}}"></app-color-picker-input>
            <app-color-picker-input [(ngModel)]="unit.buttonTextColor" name="buttonTextColor"
            label="{{'Answer Text Color' | translate}}"></app-color-picker-input>
            <app-color-picker-input [(ngModel)]="unit.buttonBackgroundColor" name="buttonBackgroundColor"
            label="{{'Answer Background Color' | translate}}"></app-color-picker-input>
            <app-experience-survey-edit [questions]="unit.surveyQuestions" [isPreStyleEdit]="isPreStyleEdit"
              (save)="onSurveyChange($event)">
            </app-experience-survey-edit>
            <mat-divider></mat-divider>
          }
        }

        <!-- theme -->
        <div [style.display]="isUnitTheme ? 'block' : 'none'">
          <app-unit-theme [unit]="unit" [selectedLayout]="selectedLayout" [isShowButton]="showField('buttonText')"></app-unit-theme>
        </div>

        @if (isPowerbarImage) {
          <div style="margin-bottom: 15px;">
            Click
            <a href="https://support.trendemon.com/powerbar-as-an-image" target="_blank">here</a>
            for guidelines and best practices.
          </div>
        }

        @if (canShowMedia) {
          <!-- media -->
          <div>
            <div>Media</div>
            <app-img-uploader uploadPath="tasks_logo" [imageLink]="unit.imgUrl" [isTemplateLibImage]="isPreStyleEdit"
              (imageUploaded)="unit.imgUrl = $event">
            </app-img-uploader>
          </div>
        }

        <!-- Powerbar image -->
        @if (isPowerbarImage) {
          <!-- background color -->
          <app-color-picker-input [(ngModel)]="unit.backgroundColor" name="backgroundColor" label="Background Color"
          style="margin-bottom: 15px"></app-color-picker-input>
          @if(!isPowerbarImage) {
            <!-- custom css -->
            <mat-form-field class="form-field-textarea">
              <mat-label>{{'Custom CSS' | translate}}</mat-label>
              <textarea matInput name="css" rows="5" [(ngModel)]="unit.css"></textarea>
            </mat-form-field>
          }
        }

        <!-- media video -->
        @if (showField('script')) {
          <div class="form-field-textarea">
            <mat-form-field class="form-field-textarea">
              <mat-label>{{'Video code' | translate}}</mat-label>
              <textarea matInput placeholder="Video Code Snippet" name="Video" [(ngModel)]="unit.videoScript" rows="5"
              required appSupportedVideo></textarea>
            </mat-form-field>
          </div>
          @if (videoScript?.hasError('supportedScripts')) {
            <mat-error translate>
              For now we don't support video platform that you are trying to use
            </mat-error>
          }
          @if (videoScript?.hasError('inlineScripts')) {
            <mat-error translate>
              The inline scripts are not allowed
            </mat-error>
          }
          <p translate>*recommended video size: 260 X 146px</p>
        }

        <!-- customize close button -->
        @if (!isEmbedded) {
          <mat-checkbox class="no-left-margin" [checked]="isCustomCloseBtn && !!unit.closeButton"
            (change)="onCustomCloseBtnChange($event.checked)">
            {{'Customize Close Button' | translate}}
          </mat-checkbox>
        }
        @if (isCustomCloseBtn && !!unit.closeButton) {
          <mat-form-field subscriptSizing="dynamic" class="form-field-bottom-marging">
            <mat-label>{{'Shape' | translate}}</mat-label>
            <mat-select [(ngModel)]="unit.closeButton.shape" class="padding-horizontal-4" name="closeButtonShape">
              <mat-option value="square" translate>Square</mat-option>
              <mat-option value="round" translate>Round</mat-option>
              <mat-option value="no" translate>Blank</mat-option>
            </mat-select>
          </mat-form-field>
          @if (unit.visibilityType!=='fixed' && unit.visibilityType!=='full' && unit.closeButton.shape !== 'no') {
            <mat-form-field subscriptSizing="dynamic" class="form-field-bottom-marging"
              >
              <mat-label>{{'Position' | translate}}</mat-label>
              <mat-select [(ngModel)]="unit.closeButton.position" class="padding-horizontal-4" name="closeButtonPosition">
                <mat-option [value]="'inside'" translate>Within Unit</mat-option>
                <mat-option [value]="'outside'" translate>On Corner</mat-option>
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field subscriptSizing="dynamic" class="form-field-bottom-marging">
            <mat-label>{{'Size (px)' | translate}}</mat-label>
            <mat-select [(ngModel)]="unit.closeButton.size" class="padding-horizontal-4" name="closeButtonSize">
              <mat-option value="17">17 px</mat-option>
              <mat-option value="18">18 px</mat-option>
              <mat-option value="19">19 px</mat-option>
              <mat-option value="20">20 px</mat-option>
              <mat-option value="21">21 px</mat-option>
              <mat-option value="22">22 px</mat-option>
              <mat-option value="23">23 px</mat-option>
              <mat-option value="24">24 px</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="colors-container">
            <app-color-picker-input [(ngModel)]="unit.closeButton.color" label="X color" name="closeButton_color"
            style="margin-bottom: 15px"></app-color-picker-input>

            @if (unit.closeButton.shape !== 'no') {
              <app-color-picker-input [(ngModel)]="unit.closeButton.background" label="Background Color"
              name="closeButton_background" position="top-left" style="margin-bottom: 15px"></app-color-picker-input>
              <app-color-picker-input [(ngModel)]="unit.closeButton.border" label="Border Color" name="closeButton_border"
              position="top-left" style="margin-bottom: 15px"></app-color-picker-input>
            }
          </div>
        }

        @if (!isUnitTheme) {
          <mat-form-field class="form-field-textarea form-field-margin-top">
            <mat-label>{{'Custom CSS' | translate}}</mat-label>
            <textarea matInput name="css" rows="5" [(ngModel)]="unit.css"></textarea>
          </mat-form-field>
        }

        <!-- marketing automation -->
        @if (showField('fields')) {
          <mat-divider></mat-divider>
          <div>
            @if(isAnyExportLeadsIntegration) {
              <div>
                {{'Publish Lead to:' | translate }}
                <mat-form-field class="padding-horizontal-4">
                  <mat-label translate>Choose Marketing Automation</mat-label>
                  <mat-select matNativeControl [(ngModel)]="unit.maProvider" name="maProvider"
                    (selectionChange)="loadIntegrationsFieldsLists($event.value)">
                    <mat-option translate>Without export</mat-option>
                    @for (integration of exportLeadsIntegrations; track integration) {
                      <mat-option [value]="integration.integrationId">
                        {{IntegrationType[integration.integrationId]}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            <div>
              <div>Form Fields</div>
              <app-experience-form-fields [formFields]="unit.formFields" [maFields]="exportLeadsMaFields"
                [integrationId]="unit.maProvider" [formReset]="formReset" (saved)="onFieldsChange($event)">
              </app-experience-form-fields>
            </div>
          </div>

          @if(unit.maProvider) {
            @if(unit.maProvider!==IntegrationType.salesforce && exportLeadsMaLists && exportLeadsMaLists.length>0) {
              <div>
                <mat-form-field>
                  <mat-label translate>{{IntegrationType[unit.maProvider]}} Static List Id
                    (not required)
                  </mat-label>
                  <mat-select [(ngModel)]="unit.maProviderListToSendLeads" class="padding-horizontal-4"
                    name="maProviderListToSendLeads">
                    <mat-option translate>Nothing Selected</mat-option>
                    @for (list of exportLeadsMaLists; track list.id) {
                      <mat-option [value]="list.id" translate>
                        {{list.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

              </div>
            }

            @if(unit.maProvider===IntegrationType.hubspot) {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{'HubSpot Form GUID (not required):' | translate}}</mat-label>
                  <input matInput placeholder="Form GUID" [(ngModel)]="unit.maFormReference" name="maFormReference">
                </mat-form-field>
                <div class="small-text" translate>If you want lead to be sent to HubSpot with it's website activity history,
                  enter here HubSpot Form GUID.
                  The requirement to this form - it should have the same fields as the current form.
                </div>
              </div>
            }
          }
        }

        <!-- leads notification -->
        @if (showField('leadsNotification') && !isPreStyleEdit) {
          <div class="margin-vertical-10">
            <mat-checkbox name="emailNotificationEnabled" [(ngModel)]="unit.emailNotificationEnabled" translate>
              Send Leads Notification
            </mat-checkbox>
            @if (unit.emailNotificationEnabled) {
              <div>
                <mat-form-field class="full-width">
                  <mat-label>my&#64;email.com OR my&#64;email.com,colleague&#64;email.com</mat-label>
                  <input matInput name="emailNotificationList" [(ngModel)]="unit.emailNotificationList" required
                    pattern="^((\w+([\-\+\.']\w+)*@\w+([\-.]\w+)*\.\w+([\-.]\w+)*)*([,])*)*$" />
                  </mat-form-field>
                </div>
              }
            </div>
          }

        </form>

